module.exports = __webpack_public_path__ + "img/magento.8a777d6b.jpg";